import { render, staticRenderFns } from "./addtask.vue?vue&type=template&id=39258f3a&scoped=true&"
import script from "./addtask.js?vue&type=script&lang=js&"
export * from "./addtask.js?vue&type=script&lang=js&"
import style0 from "./addtask.vue?vue&type=style&index=0&id=39258f3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39258f3a",
  null
  
)

export default component.exports